import { render, staticRenderFns } from "./NewNumber.vue?vue&type=template&id=791fa6d1&"
import script from "./NewNumber.vue?vue&type=script&lang=js&"
export * from "./NewNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports